import React from 'react'
import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { IconType } from 'src/design_system/atoms/icons/types'

type MembershipRewardsWidgetProps = {
  title?: string
  subtitle?: string
  amount?: number
  icon?: IconType
}

const ICON_SIZE = 52

export const MembershipRewardsWidget: React.FC<
  MembershipRewardsWidgetProps
> = ({
  title = 'Membership Rewards',
  subtitle = 'Rewards Balance',
  amount = 0,
  icon = 'reward_coin',
}) => {
  return (
    <Flex
      flexDirection="column"
      alignItems="stretch"
      backgroundColor="foreground"
      borderRadius="32px"
      inset={{ vertical: 'x2', horizontal: 'x2_5' }}
      boxShadow="light"
      height="230px"
      width="100%"
      rowGap="x1_5"
    >
      <Flex width="100%" alignItems="center" columnGap="x1">
        <Icon name={icon} size={ICON_SIZE} />
        <Text
          type="body"
          weight="bold"
          color="primaryHeading"
          content={title}
        />
      </Flex>
      <Div
        style={{
          height: 1,
          width: '100%',
          backgroundColor: '#EEF0F2',
        }}
      />
      <Flex
        flexDirection="column"
        rowGap="x_5"
        style={{
          backgroundColor: '#f5f6f7',
          borderRadius: 16,
          padding: '16px',
        }}
      >
        <Text type="caption" color="primaryBody" content={subtitle} />
        <Flex alignItems="baseline" columnGap="x_5">
          <Text
            type="subtitle"
            weight="bold"
            color="primaryHeading"
            content={amount.toLocaleString()}
          />
          <Text type="caption" color="primaryBody" content="points" />
        </Flex>
      </Flex>
    </Flex>
  )
}

export default MembershipRewardsWidget
